import React from 'react';
import styles from './PillsWrapper.module.scss';

const PillsWrapper = ({ children }: { children?: React.ReactNode }) => {
  return <div className={styles.wrapper}>{children}</div>;
};

export default PillsWrapper;
